import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = { class: "hero-section" }
const _hoisted_3 = { class: "hero-content" }
const _hoisted_4 = { class: "hero-image-container" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "hero-text-container" }
const _hoisted_7 = {
  id: "projects",
  class: "projects-section"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_project_preview_list = _resolveComponent("project-preview-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavBar),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "sections-wrapper",
        style: _normalizeStyle({ transform: `translateY(-${_ctx.currentSection * 100}vh)` })
      }, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: require('@/assets/image/timothe_photo.jpg'),
                alt: "Timothé Natté",
                class: "hero-image"
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "hero-name" }, [
                _createTextVNode("Timothé "),
                _createElementVNode("span", { class: "highlight" }, "Natté")
              ], -1)),
              _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "hero-title" }, "Étudiant en BUT Informatique", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "hero-description" }, " Passionné par le développement Full Stack et l'architecture logicielle, je suis un développeur curieux et autonome, toujours prêt à relever des défis techniques pour concevoir des solutions innovantes et performantes. ", -1)),
              _createElementVNode("div", {
                class: "scroll-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToSection(1)))
              }, _cache[1] || (_cache[1] = [
                _createElementVNode("span", null, "Découvrir mes projets", -1),
                _createElementVNode("i", { class: "mdi mdi-chevron-down bounce" }, null, -1)
              ]))
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_7, [
          _createVNode(_component_project_preview_list)
        ])
      ], 4)
    ])
  ], 64))
}